import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseCollectionComponent } from '../base-collection.component';

@Component({
  selector: 'boi-radio-button-group',
  templateUrl: './radio-button-group.component.html',
  styleUrls: ['./radio-button-group.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: RadioButtonGroupComponent,
      multi: true
    }
  ]
})
export class RadioButtonGroupComponent extends BaseCollectionComponent {
  @Input() radioButtonGroupLabel: string;
  @Input() public isTooltipLast = true;
  @Input() public disabledOptionCodes: Array<string> = [];
  @Input() public detailsLabel: string;
}
